import { useQuery } from "@tanstack/react-query";
import { Product, ProductFilterData } from "models";
import { ProductService } from "services";

export const useProducts = () => {
	const { data: products, isFetching, error } = useQuery({
		queryKey: ['products'],
		queryFn: ProductService.getAll
	})
	const filterFunction = (items: Product[], filterData: ProductFilterData) => {
		return items.filter((product: Product) => {
			if (filterData.name && !product.name.toLowerCase().includes(filterData.name.toLowerCase())) {
				return false;
			}
			if (filterData.basePriceFrom && product.basePrice < filterData.basePriceFrom) {
				return false;
			}
			if (filterData.basePriceTo && product.basePrice > filterData.basePriceTo) {
				return false;
			}
			if (filterData.bonusPointsFrom && product.bonusPoints < filterData.bonusPointsFrom) {
				return false;
			}
			if (filterData.bonusPointsTo && product.bonusPoints > filterData.bonusPointsTo) {
				return false;
			}
			return true;
		});
	};

    return { products, isFetching, error, filterFunction };
}